import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { CarVideos } from '../../assests/ExportImageIcon'
import MainTab from '../../componants/mainTab/MainTab'
import PopularDestination from '../popularDestination/PopularDestination'
import SpecialOffer from '../specialOffer/SpecialOffer'
import InfluencerReels from '../influencerReels/InfluencerReels'
import GetApp from '../getApp/GetApp'
import OurLatestBlog from '../ourLatestblog/OurLatestBlog'
import CarLocationAutocomplete from '../../componants/carLocationAutocomplete/CarLocationAutocomplete'
import DatePicker from '../../componants/datePicker/DatePicker'
import service from '../../services/service'
import endpoints from '../../services/endpoints'
import { showToast } from '../../componants/toast/toastService'
import { getClientIp } from '../../utils/clientIp'
import { setCarLocations, setCarResults, setCarSearchParams, setCarSearching } from '../../redux/carRentalSearch/carRentalSearchSlice'

const todayIso = () => new Date().toISOString().split('T')[0]

const CarRentalMain = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const locations = useSelector((state) => state.carRentalSearch.locations)
  const savedParams = useSelector((state) => state.carRentalSearch.searchParams)

  const [locationsLoading, setLocationsLoading] = useState(false)
  const [pickupLocation, setPickupLocation] = useState(savedParams.pickupLocation)
  const [dropoffLocation, setDropoffLocation] = useState(savedParams.dropoffLocation)
  const [pickupDate, setPickupDate] = useState(savedParams.pickupDate || todayIso())
  const [pickupTime, setPickupTime] = useState(savedParams.pickupTime)
  const [dropoffDate, setDropoffDate] = useState(savedParams.dropoffDate || todayIso())
  const [dropoffTime, setDropoffTime] = useState(savedParams.dropoffTime)
  const [driverAge, setDriverAge] = useState(savedParams.driverAge)

  useEffect(() => {
    if (locations.length) return
    setLocationsLoading(true)
    getClientIp()
      .then((ip) => service.post(endpoints.cars.locations, { ip_address: ip }, { silent: true }))
      .then(({ data }) => {
        dispatch(setCarLocations(data.data || []))
      })
      .catch(() => {
        showToast('Unable to load pick-up locations right now.', 'error')
      })
      .finally(() => setLocationsLoading(false))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const handleSearch = () => {
    if (!pickupLocation || !dropoffLocation) {
      showToast('Please select both pick-up and drop-off locations', 'error')
      return
    }
    if (!pickupDate || !dropoffDate) {
      showToast('Please select pick-up and drop-off dates', 'error')
      return
    }

    dispatch(setCarSearchParams({
      pickupLocation,
      dropoffLocation,
      pickupDate,
      pickupTime,
      dropoffDate,
      dropoffTime,
      driverAge,
    }))
    dispatch(setCarResults(null))
    dispatch(setCarSearching(true))
    navigate('/car-list')

    // Search runs in the background; the list page shows a loader
    // (driven by isSearching) until results land in the store.
    ;(async () => {
      try {
        const ip = await getClientIp()
        const payload = {
          ip_address: ip,
          pickup_id: String(pickupLocation.id),
          dropoff_id: String(dropoffLocation.id),
          pickup_date: pickupDate,
          pickup_time: pickupTime,
          dropoff_date: dropoffDate,
          dropoff_time: dropoffTime,
          driver_age: String(driverAge),
          country_res: savedParams.countryRes,
          currency: savedParams.currency,
        }
        const { data } = await service.post(endpoints.cars.search, payload, { timeout: 45000, silent: true })
        dispatch(setCarResults(data.data))
      } catch {
        // error toast already shown by the service interceptor
      } finally {
        dispatch(setCarSearching(false))
      }
    })()
  }

  return (
    <>
        <section className='banner'>
            <div className='videoPart'>
                <video className='promoBanner' autoPlay loop muted playsinline="" data-object-fit="cover" preload="metadata">
                    <source src={CarVideos} type="video/mp4" />
                </video>
            </div>            
            <div className='bannerContent'>
                <div className='container'>
                    <div className='row g-4'>
                        <div className='col-md-12'>
                            <h1>Book Your Car With Just One Click</h1>
                            <MainTab />
                        </div>
                        <div className='col-md-12'>
                            <div className='bookingAreaanner'>

                                <div className='hotelSearchArea mt-0'>
                                    <div className='hotelSearchUp'>
                                        <div className='hotelSearchField cmnBdr'>
                                            <div className='hotelSearchInput'>
                                                <CarLocationAutocomplete
                                                    label='Pick-up Location'
                                                    placeholder='Enter city or location'
                                                    value={pickupLocation}
                                                    onChange={setPickupLocation}
                                                    locations={locations}
                                                    loading={locationsLoading}
                                                />
                                            </div>
                                        </div>
                                        <div className='hotelSearchField cmnBdr'>
                                            <div className='hotelSearchInput'>
                                                <CarLocationAutocomplete
                                                    label='Drop-off Location'
                                                    placeholder='Enter city or location'
                                                    value={dropoffLocation}
                                                    onChange={setDropoffLocation}
                                                    locations={locations}
                                                    loading={locationsLoading}
                                                />
                                            </div>
                                        </div>
                                        <div className='hotelSearchField cmnBdr'>
                                            <div className='hotelSearchInput'>
                                                
                                                <div>
                                                    <span className='cruiseSearchPill__label'>Pick-up Date &amp; Time</span>
                                                    <DatePicker className='searchBarDateField' min={todayIso()} value={pickupDate} onChange={setPickupDate} />
                                                    <input type='time' value={pickupTime} onChange={(e) => setPickupTime(e.target.value)} />
                                                </div>
                                            </div>
                                        </div>
                                        <div className='hotelSearchField cmnBdr'>
                                            <div className='hotelSearchInput'>
                                                
                                                <div>
                                                    <span className='cruiseSearchPill__label'>Drop-off Date &amp; Time</span>
                                                    <DatePicker className='searchBarDateField' min={pickupDate || todayIso()} value={dropoffDate} onChange={setDropoffDate} />
                                                    <input type='time' value={dropoffTime} onChange={(e) => setDropoffTime(e.target.value)} />
                                                </div>
                                            </div>
                                        </div>
                                        <div className='hotelSearchField'>
                                            <div className='hotelSearchInput'>
                                                <div>
                                                    <span className='cruiseSearchPill__label'>Driver's Age</span>
                                                    <input type='number' min='18' max='99' value={driverAge} onChange={(e) => setDriverAge(e.target.value)} />
                                                </div>
                                            </div>
                                        </div>
                                        <button type='button' className='commonBtn' onClick={handleSearch}>
                                            Search Car
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>            
        </section>

        <PopularDestination />

        <SpecialOffer />

        <InfluencerReels />

        <GetApp />

        <OurLatestBlog />
    </>
  )
}

export default CarRentalMain
